import * as React from 'react';
import { Prices } from '../../__types__/generated/cluster';
import { currency } from '../../utils/format/currency';


const Price: React.FC<{ prices?: Prices }> = ({ prices }) => {
    if (!prices) return null;


    const askingPrice = currency({ number: prices.askingPrice ?? 0 });
    const askingPriceTo = prices.askingPriceTo ? ` - ${currency({ number: prices.askingPriceTo ?? 0 })}` : '';

    return (
        <span>{`${askingPrice}${askingPriceTo},-`}</span>
    );
};

export default Price;